"use client";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { FC } from "react";

import { createUrl } from "@/lib/utils";
import { SORT } from "@/lib/constants";

export type SortOrderTypes = {
  key: string;
  title: string;
  value: string;
  sort: string;
  order: string;
  position: string;
};

const SortOrder: FC<{
  sortOrders: SortOrderTypes[];
  title: string;
}> = ({ sortOrders, title }) => {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();
  const sort = searchParams.get(SORT) || "name-asc";

  const handleSortChange = (value: string) => {
    const newParams = new URLSearchParams(searchParams.toString());

    if (value) newParams.set(SORT, value);
    const newUrl = createUrl(pathname, newParams);

    router.replace(newUrl);
  };

  return (
    <section className="flex w-64 items-center gap-x-2.5 dark:text-white">
      <p id="sort-label" className="leading-0 text-nowrap min-[1300]:block hidden">
        {title}
      </p>
      <Select value={sort} onValueChange={handleSortChange}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Select a Sort Order" />
        </SelectTrigger>
        <SelectContent>
          {sortOrders.map((order) => (
            <SelectItem key={order.value} value={order.value}>
              {order.title}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </section>
  );
};

export default SortOrder;
